import { paths } from '@/models/api/v1';
import createClient from 'openapi-fetch';

export default function apiClient() {
    return createClient<paths>({
		baseUrl: process.env.VUE_APP_TRACKING_BACKEND_URL
	});
}
export type ApiClient = ReturnType<typeof apiClient>;

